module.exports = __webpack_public_path__ + "img/ic_12_drag.835d68fb.svg";